import React from 'react'
import { useRBAC } from '../../context/RBACContext'
import { useI18n } from '../../i18n/I18nContext'

interface WorkspaceCardProps {
  title: string
  description: string
  cta: string
  feature: string
  group?: string
  hasAccessOverride?: boolean
  active?: boolean
  disabled?: boolean
  onClick: () => void
  testId: string
}

export const WorkspaceCard: React.FC<WorkspaceCardProps> = ({
  title,
  description,
  cta,
  feature,
  group,
  hasAccessOverride,
  active = false,
  disabled = false,
  onClick,
  testId,
}) => {
  const { hasFeature } = useRBAC()
  const { t } = useI18n()
  const hasAccess = hasAccessOverride ?? hasFeature(feature)

  if (!hasAccess) {
    return null
  }

  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={`workspace-card ${active ? 'active' : ''}`}
      type="button"
      aria-current={active ? 'page' : undefined}
      aria-pressed={active}
      title={cta}
      data-testid={testId}
    >
      {group ? <span className="workspace-card__group">{group}</span> : null}
      <span className="workspace-card__title-row">
        <h3>{title}</h3>
        {active ? <span className="workspace-card__current">{t('Current')}</span> : null}
      </span>
      <p className="text-muted">{description}</p>
      <span className="workspace-card__cta" aria-hidden="true">→</span>
    </button>
  )
}
